document.addEventListener('DOMContentLoaded', function () {
  // 許可する文字（英語＋日本語＋数字＋記号）
  const allowedPattern = /^[\x09\x0A\x0D\x20-\x7E\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF\uFF00-\uFFEF]*$/;

  // 対象フォーム：contact と cart
  const targetForms = document.querySelectorAll(
    'form[action*="/contact"], form[action*="/cart"]'
  );

  targetForms.forEach(function (form) {
    const fields = form.querySelectorAll('input[type="text"], input[type="tel"], textarea');

    fields.forEach(function (field) {
      field.addEventListener('input', function () {
        if (!allowedPattern.test(this.value)) {
          this.setCustomValidity(
            '英語または日本語のみ入力してください / Please enter in English or Japanese only.'
          );
        } else {
          this.setCustomValidity('');
        }
      });

      // フォーカスが外れたタイミングでエラー表示
      field.addEventListener('blur', function () {
        this.reportValidity();
      });
    });
  });
});